import React from 'react';
import { Row, Col, Alert } from '@cochlear-design-system/foundation';

export const NotiAlert = ({ config }) => {
  const { visible, message, type, dismissible } = config;

  if (!visible) {
    return null;
  }

  return (
    <Row>
      <Col xs={12}>
        <Alert
          defaultShow
          variant={type}
          dismissible={dismissible}
          heading=""
          actions={[]}
        >
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: message,
            }}
          />
        </Alert>
      </Col>
    </Row>
  );
};
